import { useState, useEffect, useCallback } from 'react';
import { organizationAPI } from '../services/strategicPerformanceApi';
import { toast } from 'sonner';

export const useOrganizationSettings = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadSettings = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await organizationAPI.getSettings();
      setLogoUrl(data?.logoUrl || null);
    } catch (error) {
      console.error('Error loading organization settings:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const uploadLogo = async (file: File): Promise<string> => {
    try {
      const result = await organizationAPI.uploadLogo(file);
      setLogoUrl(result.logoUrl);
      // Reload settings to ensure consistency
      await loadSettings();
      return result.logoUrl;
    } catch (error) {
      console.error('Error uploading logo:', error);
      throw error;
    }
  };

  const removeLogo = async () => {
    try {
      await organizationAPI.deleteLogo();
      setLogoUrl(null);
      // Reload settings to ensure consistency
      await loadSettings();
    } catch (error) {
      console.error('Error removing logo:', error);
      throw error;
    }
  };

  return {
    logoUrl,
    uploadLogo,
    removeLogo,
    isLoading,
    refetch: loadSettings,
  };
};
